import { Provider } from '@vgtv/api-client';

import { getCurrentPageViewData } from '../../../../services/tracking/helpers/pulseOrigin';
import { rawTrackViewEvent } from '../../../../services/tracking/pulse';
import {
  type ProviderSubscriptionMap,
  trackSubscribeClickEvent,
} from '../../../../services/tracking/pulseEvents';
import { tryUrlFromString } from '../../../../shared/helpers/url';

const isPurchaseIntent = (element: HTMLAnchorElement) => {
  const url = tryUrlFromString(element.href);

  return url?.hostname === 'payment.schibsted.com';
};

export const trackSalesposterLinkClick = async (
  e: MouseEvent,
  element: HTMLAnchorElement,
  access: string,
  campaignId: string
) => {
  if (!isPurchaseIntent(element)) {
    return;
  }

  e.preventDefault();

  try {
    await trackSubscribeClickEvent({
      button: {
        elementIdentifier: `SalesposterLink:${campaignId}`,
        elementType: 'SalesposterLink',
        title: element.innerText || 'SalesposterLink',
      },
      subscription: {
        provider: Provider.VGTV,
        url: element.href.split('?')[0],
        name: access as ProviderSubscriptionMap[Provider.VGTV],
      },
    });
  } catch {
    // noop
  }

  window.location.href = element.href;
};

export const trackSalesposterView = (campaignId: string) => {
  const xDomainId = getCurrentPageViewData().xDomainId;
  rawTrackViewEvent(
    {
      object: {
        id: `salesposter:${campaignId}`,
        type: 'UIElement',
      },
    },
    xDomainId
  );
};
